<template>
  <transition name="slide-fade">
    <div v-if=" isShow">
      <!-- <div class="corList">
        <div class="txt" v-for="(item,index) in txt" :key="index">
          <img src="../../assets/images/icon_new.png" alt />
          <div @click="CorDetail(item.id,item.type)">
            <p>{{item.title}}</p>
          </div>
        </div>
      </div> -->
       <div class="cor" v-for="(item,index) in txt" :key="index">
        <div @click="CorDetail(item.id,item.type)">
          <div class="left">
            <img :src="item.imageUrl ? item.imageUrl : '/static/img/xz1.png'" />
          </div>
          <div class="right">
            <div class="title">{{item.title}}</div>
            <div class="content">导语：{{item.summary}}</div>
            <p class="date">{{item.createTime*1000 | formatDate}}</p>
          </div>
        </div>
        <div class="line"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["navID"],
  data() {
    return {
      isShow: true,
      txt: []
    };
  },
  watch: {
    navID: {
      handler: function() {
        if (this.navID === 2) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.axios
      .get("/api/consume/Information/PageList", {
        params: {
          Type: 2,
          page: 1,
          rows: 4
        }
      })
      .then(res => {
        this.txt = res.data.results;
      });
  },
  methods: {
    CorDetail(id, type) {
      this.$router.push({ path: `/newsIndex/${id}.html` });
    }
  }
};
</script>

<style scoped>

.cor {
  margin-left: 30px;
  overflow: hidden;
  padding-top: 34px;
  clear: both;
  padding-right: 30px;
  overflow: hidden;
}
.cor .left {
  float: left;
}
.cor .right {
  float: left;
  width: 65%;
}
.cor .left img {
  width: 240px;
  height: 160px;
  border-radius: 10px;
}
.cor .right .title {
  font-size: 26px;
  color: #444444;
  margin-left: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  width: 400px;
  font-weight: normal;
}
.cor .right .content {
  font-size: 22px;
  color: #8b8b8b;
  margin-top: 40px;
  margin-left: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  line-height: 32px;
  width: 400px;
}
.cor .line {
  color: #e2e2e2;
  height: 2px;
  margin-top: 190px;
}
.cor .date {
  color: #e2e2e2;
  font-size: 22px;
  clear: both;
  margin-left: 14px;
  margin-top: 5px;
}
/* .txt {
  overflow: hidden;
}
.corList img {
  width: 54px;
  height: 23px;
  float: left;
  margin-top: 5px;
  margin-left: 30px;
}
.corList p {
  color: #444444;
  font-size: 26px;
  float: left;
  margin-left: 10px;
}
.txt {
  border-bottom: 1px solid #e2e2e2;
  padding-bottom: 26px;
  margin-top: 26px;
  margin-left: 30px;
  margin-right: 30px;
}
.txt p {
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  width: 420px;
} */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(130px);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/Cor.vue